import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from "@syncfusion/ej2-angular-richtexteditor";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";
import { LoadingService } from "src/app/Services/loading.service";

@Component({
  selector: "app-userguide-translation",
  templateUrl: "./userguide-translation.component.html",
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService],
  standalone: false,
})
export class UserguideTranslationComponent implements OnInit {
  @Input() data: string = "";
  @Input() placeholder: string = "";
  @Input() userguideData;

  /*  : {
    screenDetails: {};
    primaryLanguage: { id: ""; updatedAt: "" };
    supportedLanguage: { id: ""; updatedAt: "" };
  }; */
  @Input() languageId;
  @Input() languageList;

  @Output() save = new EventEmitter<string>();

  isEditing: boolean = false;

  public toolbarSettings: object = {
    items: ["Bold", "Italic", "Underline", "Formats", "Undo", "Redo"],
  };

  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private crudService: CrudService,
    private loadingService: LoadingService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    if (!this.data) {
      this.isEditing = true;
      this.data = "";
    }
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  saveEdit() {
    var self = this;
    var updatedSupportedLanguages;
    const languageObj = this.languageList.find(
      (lang) => lang.id === this.languageId
    );

    this.loadingService.show();
    const newLanguageEntry = {
      ...languageObj,
      text: this.data != "" ? this.data : "",
      updatedAt: new Date().toISOString().replace("Z", "+00:00"),
    };
    if (
      !this.userguideData["supportedLanguages"] ||
      this.userguideData["supportedLanguages"].length === 0
    ) {
      // If empty, add the new entry as the first item
      updatedSupportedLanguages = [newLanguageEntry];
    } else {
      const found = this.userguideData["supportedLanguages"].some(
        (lang) => lang.id === this.languageId
      );

      if (found) {
        // Replace the matching language with updated entry
        updatedSupportedLanguages = this.userguideData[
          "supportedLanguages"
        ].map((lang) =>
          lang.id === this.languageId ? newLanguageEntry : lang
        );
      } else {
        // Append the new language entry if it doesn't exist
        updatedSupportedLanguages = [
          ...this.userguideData["supportedLanguages"],
          newLanguageEntry,
        ];
      }
    }

    this.userguideData["supportedLanguages"] = updatedSupportedLanguages;
    if (!this.data) {
      self.toastr.error("Text required.", "Invalid Operation");
      return;
    }

    var payload = {
      ...this.userguideData,
      supportedLanguages: updatedSupportedLanguages,
    };

    this.crudService.update(
      payload,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          self.toastr.success(
            "The User Guide has been created successfully.",
            "Success"
          );
          self.save.emit();
          self.isEditing = false;
        }
      },
      "currentUserGuideDetails/" + this.userguideData["id"]
    );
  }
}
